module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "captcha-button"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "captcha-element"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-69ee7bf2!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/aliCaptcha.vue
// module id = 402
// module chunks = 40 41